// extracted by mini-css-extract-plugin
export default {"container":"clients_container__YGZA5","logoContainer":"clients_logoContainer__Ff09O","logo":"clients_logo__i7b7c","header":"clients_header__EvwbJ"};